import { render, staticRenderFns } from "./noView.vue?vue&type=template&id=ffbce5a2&scoped=true&"
import script from "./noView.vue?vue&type=script&lang=js&"
export * from "./noView.vue?vue&type=script&lang=js&"
import style0 from "./noView.vue?vue&type=style&index=0&id=ffbce5a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbce5a2",
  null
  
)

export default component.exports